import TextBubbles from '@home/components/TextBubbles';
import TableCommonHook from '@op/components/TableCommonHook';
import { formatFilterDate } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';
import { useIntl } from 'umi';

interface IColumns {
  key: string;
  name: string;
  align: string;
  header: React.ReactNode;
  render: (cvm: any) => React.ReactNode;
  width?: number;
}
export default function Table(props: any) {
  const {
    gameInfo,
    filter,
    records = [],
    height,
    columnsConfig
  } = props;

  const { formatMessage } = useIntl();
  const tableColumns = useMemo(() => {
    const columns: IColumns[] = [
      {
        key: 'time',
        name: 'Date',
        align: 'left',
        header: formatMessage({ id: 'Date' }),
        render: (cvm: any) => formatFilterDate(cvm.time, filter),
        width: 150
      },
    ];

    columnsConfig.forEach((item: any) => {
      const { name, key, align = 'right', valueFormat = reviewsFormat } = item;
      columns.push({
        key,
        header: (<TextBubbles text={formatMessage({ id: name })} />),
        align,
        render: (cvm: any) => valueFormat(cvm?.[key] || '-'),
        name,
      });
    });

    return columns;
  }, [columnsConfig, formatMessage, filter]);

  return (
    <TableCommonHook
      recordKey={'key'}
      columns={tableColumns}
      total={records.length}
      records={records}
      hasPageable={false}
      maxHeight={height - 50}
      minWidth={'auto'}
      style={{
        height
      }}
    />
  );
};